import { PropertyKind } from "shared/types";

export const getPropertyKindLabel = (
  kind: PropertyKind | null | undefined
): string | null => {
  if (kind === PropertyKind.ManufacturedHousing) return "Mobile Home";
  if (kind === PropertyKind.SingleFamily) return "Single family";
  if (kind === PropertyKind.MultiFamily) return "Multi family";
  return null;
};
